export default __webpack_public_path__ + "static/media/speechToText.1c9f67be.png";